import { useEffect, useState } from 'react'
import AppIcon from '../icons/AppIcon'
import Overlay from '../primitives/Overlay'
import styles from './ChatScreen.module.css'

interface ChatImageViewerProps {
  images: string[]
  currentIndex: number
  onClose: () => void
  onNavigate?: (index: number) => void
}

export default function ChatImageViewer({
  images,
  currentIndex,
  onClose,
  onNavigate,
}: ChatImageViewerProps) {
  const [index, setIndex] = useState(currentIndex)

  useEffect(() => {
    setIndex(currentIndex)
  }, [currentIndex])

  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      if (event.key === 'ArrowLeft' && index > 0) {
        const next = index - 1
        setIndex(next)
        onNavigate?.(next)
      }
      if (event.key === 'ArrowRight' && index < images.length - 1) {
        const next = index + 1
        setIndex(next)
        onNavigate?.(next)
      }
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [index, images.length, onNavigate])

  if (images.length === 0) return null

  return (
    <Overlay variant="fullscreen" onClose={onClose} ariaLabel="Image">
      <div className={styles.viewer} onClick={onClose}>
        <div className={styles.viewerTop}>
          <span>{images.length > 1 ? `${index + 1} of ${images.length}` : ''}</span>
          <button type="button" className={styles.viewerClose} onClick={onClose} aria-label="Close">
            <AppIcon icon="mdi:close" size={22} />
          </button>
        </div>
        <div className={styles.viewerBody} onClick={(event) => event.stopPropagation()}>
          <img src={images[index]} alt={`Image ${index + 1}`} />
        </div>
      </div>
    </Overlay>
  )
}
